<h3>Search {{searchPhrase}}</h3>
<p *ngIf="!policies">Loading...</p>
<nz-table *ngIf="policies"
	[nzBordered]="true"
	[nzData]="policies"
	[nzFrontPagination]="false"
	[nzShowPagination]="false">
	<thead>
		<tr>
			<th>Policy Number</th>
			<th>Product</th>
			<th>Offer</th>
			<th>Member Details</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let policy of policies; let i = index" class="cursor-pointer" (dblclick)="openPolicy(policy)">
			<td>{{ policy.policyNumber }}</td>
			<td>{{ policy.product!.name }}</td>
			<td>{{ policy.productOffer!.name }}</td>
			<td>{{ policy.member!.surname }} {{policy.member!.name}}</td>
		</tr>
	</tbody>
</nz-table>
